import { Card, Input, CardBody, Chip, Popover, PopoverContent, PopoverTrigger, Table, TableBody, TableCell, TableRow, TableColumn, TableHeader, Button, CardFooter, useSelect, Checkbox, SelectItem, Select } from "@nextui-org/react"
import { useEffect, useMemo, useState } from "react"
import { ErrorCard, MainContainer } from "../../components"
import { useSelector } from "react-redux"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { usePost } from "../../api/reactQueryCustomHooks"
import { apiRoute } from "../../constants/enum"
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers"
import dayjs from "dayjs"
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs"
import { faCalendarAlt, faChartBar, faExclamationTriangle } from "@fortawesome/free-solid-svg-icons"
import { toast } from "react-toastify"
import { isMobile } from "react-device-detect"
import ApexCharts from "react-apexcharts";
import { fontSize } from "@mui/system"
import { color } from "framer-motion"
//import StackedFabricChart from "../sample/Test"


const ENUM_YARNCOST_BY = {
    PurchaseRate: "PR",
    YarnRate: "YR"
}
const GrayItemCostingDashboard = () => {
    const { user } = useSelector((state) => state.auth)
    const { compCode, yearId, startDate, endDate } = useSelector((state) => state.company)
    const [yarnCostBy, setYarnCostBy] = useState(ENUM_YARNCOST_BY.PurchaseRate)
    // if (isError) {
    //     return <ErrorCard />
    // }
    const [filterDate, setFilterDate] = useState({
        start: startDate ? dayjs(startDate).format("YYYY-MM-DD") : null,
        end: endDate ? dayjs(endDate).format("YYYY-MM-DD") : null
    })
    const { isError, isPending, data = [], mutate: filterData } = usePost({
        url: apiRoute.mainDashboard.itemWiseCosting.getItemCostingData,
        queryKey: "Fetch main Dashboard data",
    })
    const { isPending: isPendingQua, data: qualityData = [], mutate: filtrQualityData } = usePost({
        url: apiRoute.mainDashboard.itemWiseCosting.getItemCostingData,
        queryKey: "Fetch main Dashboard Quality data",
    })
    const funLoadData = () => {
        let error = ""
        const start = dayjs(filterDate.end)
        const end = dayjs(filterDate.start)
        const months = start.diff(end, 'month');
        const t_year = dayjs(startDate).format('YYYY')
        const minDate = t_year - 2 + "-" + dayjs(startDate).format('MM') + "-" + dayjs(startDate).format('DD')

        if (!dayjs(filterDate.start).isValid || !dayjs(filterDate.end).isValid ||
            filterDate.start == "Invalid date" || filterDate.end == "Invalid Date" ||
            filterDate.start == null || filterDate.end == null) {
            toast.error("Inavlid Start / End Date ", {
                "position": "top-center"
            })

        }
        else {
            if (dayjs(filterDate.start).isValid && dayjs(filterDate.end).isValid) {
                if ((dayjs(filterDate.end).format("YYYY-MM-DD") < dayjs(minDate).format("YYYY-MM-DD")) ||
                    (dayjs(filterDate.start).format("YYYY-MM-DD") < dayjs(minDate).format("YYYY-MM-DD"))) {

                    error += `Start / End Date must not be less than ${dayjs(minDate).format("DD-MM-YYYY")},`

                }
            }
            if (dayjs(filterDate.end).isValid && dayjs(filterDate.start).isValid) {
                if ((dayjs(filterDate.end).format("YYYY-MM-DD") > dayjs(endDate).format("YYYY-MM-DD")) ||
                    (dayjs(filterDate.start).format("YYYY-MM-DD") > dayjs(endDate).format("YYYY-MM-DD"))) {

                    error += `Start / End Date must not be greater than ${dayjs(endDate).format("DD-MM-YYYY")},`

                }
            }
            if (months > 12) error += "Date period must not be greater than 1 year,"
            if (error == "") {
                filterData({
                    data: {
                        compcode: compCode.join(","),
                        fromdate: filterDate.start,
                        todate: filterDate.end,
                        action: '',
                        db_inilchar: yearId ? yearId.substring(0, yearId.length - 4) : 'ACC',
                    }
                })

                filtrQualityData({
                    data: {
                        compcode: compCode.join(","),
                        fromdate: filterDate.start,
                        todate: filterDate.end,
                        action: 'MonthSummary',
                        db_inilchar: yearId ? yearId.substring(0, yearId.length - 4) : 'ACC'
                    }
                })
            }
            else {
                const messages = error.split(',');
                toast.error(
                    <div>
                        {messages.map((msg, idx) => msg != "" ? (

                            <div key={idx} className="p-1">
                                <FontAwesomeIcon className="mr-2" icon={faExclamationTriangle} ></FontAwesomeIcon>
                                {msg.trim()}</div> // Trim to remove extra spaces
                        ) : "")}
                    </div>,
                    {
                        position: "top-center",
                        icon: false,
                        style: { whiteSpace: 'pre-line', width: '400px', fontSize: "0.8rem", color: "#da3333ff" }, // Optional here, mostly needed if using \n
                    }
                );
            }
        }
    }
    useEffect(() => {
        funLoadData()

    }, [])

    useEffect(() => {
        if (yarnCostBy == "" || yarnCostBy == null)
            setYarnCostBy(ENUM_YARNCOST_BY.PurchaseRate)

    }, [yarnCostBy])
    const handleChange = (e) => {
        const { name, value } = e.target;
        setFilterDate(prev => ({
            ...prev,
            [name]: value
        }));
    };
    const handleBtnClick = (e) => {
        e.preventDefault();
        funLoadData()

    }
    const handleReset = () => {
        setFilterDate({
            start: startDate ? dayjs(startDate).format("YYYY-MM-DD") : null,
            end: endDate ? dayjs(endDate).format("YYYY-MM-DD") : null
        })
        filterData({
            data: {
                compcode: compCode.join(","),
                fromdate: dayjs(startDate).format("YYYY-MM-DD"),
                todate: dayjs(endDate).format("YYYY-MM-DD"),
                db_inilchar: yearId ? yearId.substring(0, yearId.length - 4) : 'ACC',
            }
        })
        filtrQualityData({
            data: {
                compcode: compCode.join(","),
                fromdate: dayjs(startDate).format("YYYY-MM-DD"),
                todate: dayjs(endDate).format("YYYY-MM-DD"),
                action: 'MonthSummary',
                db_inilchar: yearId ? yearId.substring(0, yearId.length - 4) : 'ACC'
            }
        })

    }

    const qualities = [...new Set(
        qualityData.map(d => (d.fitem_desc || "(No Name)").toString().trim())
    )];

    // Step 2: Aggregate totals per quality
    const totalPerQuality = useMemo(() => {

        return qualities.map(qty => {

            const filtered = qualityData.filter(
                d =>
                    (d.fitem_desc || "(No Name)")
                        .toString()
                        .trim() === qty
            )

            const isYarnRate =
                yarnCostBy === ENUM_YARNCOST_BY.YarnRate

            return {

                fitem_desc: qty,

                total_cost: filtered.reduce(
                    (sum, d) =>
                        sum +
                        (
                            isYarnRate
                                ? Number(d.avg_item_cost || 0)
                                : Number(d.avg_cost || 0)
                        ),
                    0
                ),

                sale_value: filtered.reduce(
                    (sum, d) =>
                        sum + Number(d.avg_sale || 0),
                    0
                ),

                diff_value: filtered.reduce(
                    (sum, d) =>
                        sum +
                        (
                            isYarnRate
                                ? Number(d.avg_item_diff || 0)
                                : Number(d.avg_diff || 0)
                        ),
                    0
                )

            }

        })

    }, [qualities, qualityData, yarnCostBy])

    // Step 3: Prepare series data for stacked bars
    const series = [
        {
            name: "Cost",
            data: totalPerQuality.map(
                d => d.total_cost
            )
        },

        {
            name: "Sale",
            data: totalPerQuality.map(
                d => d.sale_value
            )
        },

        {
            name: "Diff",
            data: totalPerQuality.map(
                d => d.diff_value
            )
        }
    ]

    // Step 4: ApexCharts options
    const allValues = series.flatMap(s => s.data);
    const minValue = Math.min(...allValues.filter(v => v > 0));

    const chartOptions = {
        chart: {
            type: "bar",
            stacked: true,
            toolbar: { show: true },
            height: 400
        },
        plotOptions: {
            bar: {
                horizontal: false,
                columnWidth: "60%", // adjust width
                dataLabels: {
                    position: 'top'
                }
            }
        },
        dataLabels: {
            enabled: false
        },
        xaxis: {
            categories: qualities,
            title: { text: "FABRIC ITEM" },
            labels: {
                trim: false,
                hideOverlappingLabels: false,
                rotate: -45,
                style: {
                    fontSize: "10px",
                    colors: "#000"
                }
            }
        },
        responsive: [{
            breakpoint: 480,
            options: {
                chart: {
                    // width: "100%",
                    height: "500px"
                },
                legend: {
                    floating: false,
                    position: 'bottom',
                },
            },
        }],
        yaxis: {
            // min: minValue * 0.9,   // start just below smallest value
            forceNiceScale: true,
            tickAmount: 10,
            //logarithmic: true,
            title: { text: "AMOUNT" },
            labels: {
                formatter: val => val.toFixed(2)
            }
        },
        tooltip: {
            y: {
                formatter: val => val.toFixed(2)
            }
        },
        legend: {
            position: "top",
            fontSize: "14px"
        },
        series: series,
        colors: ['#f43f5e', '#84cc16', '#f97316',],
    };

    

    //    const chartData = useMemo(() => {
    //     const result = {};

    //     qualityData.forEach(item => {
    //       const key = item.fitem_desc;

    //       if (!result[key]) {
    //         result[key] = {
    //           fitem_desc: item.fitem_desc,
    //           total_cost: 0,
    //           sale_value: 0,
    //           diff_value: 0
    //         };
    //       }

    //       result[key].total_cost += item.total_cost ?? 0;
    //       result[key].sale_value += item.sale_value ?? 0;
    //       result[key].diff_value += item.diff_value ?? 0;
    //     });

    //     return Object.values(result);
    //   }, [qualityData]);

    // console.log(chartData)
    return (
        <div>
            <MainContainer pageName="Gray Item Costing" breadcrumbs={["Dashboard", "Gray Item Costing"]}>
                <div className="flex justify-end mb-2 flex-wrap items-center gap-2">
                    <div  className=" bg-d-50 " ><Select
                        selectedKeys={[yarnCostBy]}
                        variant="bordered"
                        color="default"
                        size="sm"
                        label="Cal.Yarn Cost By : "
                        labelPlacement="outside"
                        onChange={(e) => setYarnCostBy(e.target.value)}
                        classNames={{ "label": "p-0 m-0" }}
                        className=" h-7 bg-white border-0 border-amber-400 sm:w-40 md:w-40 w-28 border-0 text-sm font-semibold"
                    >

                        <SelectItem key={ENUM_YARNCOST_BY.PurchaseRate}>Purchase Rate</SelectItem>
                        <SelectItem key={ENUM_YARNCOST_BY.YarnRate}>Yarn Rate</SelectItem>
                    </Select></div>
                    <div className="flex gap-2">
                        <Chip variant="bordered" className="border-1 border-pink-500" size="sm" color="danger" > From : {dayjs(filterDate.start).format("DD-MMM-YYYY")}</Chip>
                        <Chip variant="bordered" className="border-1 border-pink-500" size="sm" color="danger" > To : {dayjs(filterDate.end).format("DD-MMM-YYYY")}</Chip>
                    </div>                    {/* date */}

                    <Popover placement="bottom" variant="bordered"
                        isDismissable={true}
                        shouldCloseOnBlur={false}
                        shouldBlockScroll={true}
                        shouldCloseOnScroll={false}
                        showArrow={true}>
                        <PopoverTrigger>
                            <Button size="sm"
                                className="bg-sky-200  text-md border-2 border-sky-300 text-sky-600 px-1" isIconOnly={true}   >
                                <FontAwesomeIcon className="text-xl" icon={faCalendarAlt}></FontAwesomeIcon>
                            </Button>
                            {/* <Button size="sm"
                                                className="bg-sky-600 h-7 text-white" variant="shadow" color="warning"  >Change Date</Button> */}
                        </PopoverTrigger>
                        <PopoverContent className="z-[1000]">
                            <div
                                onMouseDown={(e) => e.stopPropagation()}
                                onTouchStart={(e) => e.stopPropagation()}
                            >
                                <form onSubmit={handleBtnClick} >
                                    <div className={`${isMobile ? 'flex-wrap justify-center' : ''} flex gap-2 p-4`}>
                                        <div className={`flex  gap-2 `}>

                                            <div className="relative">
                                                <input
                                                    type="date"
                                                    name="start"
                                                    value={filterDate.start}
                                                    onChange={handleChange}
                                                    required
                                                    className="block w-full p-1 text-sm border border-slate-200 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 rounded-md shadow-sm bg-white"
                                                />

                                            </div>
                                            <div className="relative">
                                                <input
                                                    type="date"
                                                    name="end"
                                                    value={filterDate.end}
                                                    onChange={handleChange}
                                                    required
                                                    className="block w-full p-1  text-sm border border-slate-200 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 rounded-md shadow-sm bg-white"
                                                />

                                            </div>
                                        </div>
                                        <div className={`flex  gap-2 `}>
                                            <Button size="sm" variant="shadow" className="bg-blue-700 h-7 text-white" type="submit" >Apply</Button>
                                            <Button size="sm" color="danger" variant="shadow" className=" h-7 text-white" onPress={handleReset} >Reset</Button>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </PopoverContent>
                    </Popover>
                </div>
                <div className="shadow pb-5 flex flex-col item-center min-w-md">
                    <div className={` h-96   ${data && data.length > 10 ? "overflow-scroll" : ""}`}>
                        {data && data?.length > 0 ?
                            (
                                <Table removeWrapper isHeaderSticky radius="none" classNames={{
                                    th: [" text-blue-700", "uppercase", "bg-gradient-to-br from-white to-sky-50","m-0"],
                                    tr: ["hover:bg-amber-50",
                                        "border-0 ", "border-sgky-700", "font-semibold", "cursor-pointer","m-0"],
                                    td: ["text-xs","font-semibold"]
                                }}
                                >
                                    <TableHeader>
                                        <TableColumn>NO.#</TableColumn>
                                        <TableColumn>Fabric Item</TableColumn>
                                        <TableColumn className="text-center">TotalProd.Meter</TableColumn>
                                        <TableColumn className="text-center">Total Yarn Kgs</TableColumn>
                                        <TableColumn className="text-center">Yarn Cost</TableColumn>
                                        <TableColumn className="text-center">Fix Cost</TableColumn>
                                        <TableColumn className="text-center">Total Cost</TableColumn>
                                        <TableColumn className="text-center">Avg Cost</TableColumn>
                                        <TableColumn className="text-center">Total Sale</TableColumn>
                                        <TableColumn className="text-center">Avg Sale</TableColumn>
                                        <TableColumn className="text-center">Diff</TableColumn>
                                    </TableHeader>
                                    <TableBody className="">
                                        {
                                            data?.map((ele, i) => {
                                                const d=i+1
                                                return (
                                                    <TableRow key={i} className={` border-1 border-sky-300 ${yarnCostBy == ENUM_YARNCOST_BY.YarnRate ? 
                                                        ele.avg_item_diff>0?'bg-emerald-50 text-emerald-800':ele.avg_item_diff<0?'bg-red-100 text-red-700':'bg-white' 
                                                    : ele.avg_diff>0?'bg-emerald-50 text-emerald-800':ele.avg_diff<0?'bg-red-100 text-red-700':'bg-white'}`}>
                                                         <TableCell className="text-xs1 border-r-1 border-sky-700 w-10">
                                                            {d}
                                                        </TableCell>
                                                        <TableCell className="text-xs1">
                                                            {ele.fitem_desc}
                                                        </TableCell>
                                                        <TableCell className="text-xs1 text-right">
                                                            {ele.prod_meter}
                                                        </TableCell>
                                                        <TableCell className="text-xs1 text-right">
                                                            {ele.total_weight.toFixed(3)}
                                                        </TableCell>
                                                        <TableCell className="text-x1 text-right" >
                                                            {yarnCostBy == ENUM_YARNCOST_BY.YarnRate ? ele.yarn_item_cost.toFixed(2) : ele.yarn_cost.toFixed(2)}
                                                        </TableCell>
                                                        <TableCell className="text-x1 text-right" >
                                                            {ele.fix_cost}
                                                        </TableCell>
                                                        <TableCell className="text-x1 text-right" >
                                                            {yarnCostBy == ENUM_YARNCOST_BY.YarnRate ? ele.total_item_cost.toFixed(2) : ele.total_cost.toFixed(2)}
                                                        </TableCell>
                                                        <TableCell className="text-x1 text-right" >
                                                            {yarnCostBy == ENUM_YARNCOST_BY.YarnRate ? ele.avg_item_cost.toFixed(2) : ele.avg_cost.toFixed(2)}
                                                        </TableCell>
                                                       
                                                        
                                                         <TableCell className="text-x1 text-right" >
                                                            {ele.sale_value}
                                                        </TableCell>
                                                        <TableCell className="text-x1 text-right" >
                                                            {ele?.avg_sale.toFixed(2)}
                                                        </TableCell>
                                                        <TableCell className="text-x1 text-right" >
                                                           {yarnCostBy == ENUM_YARNCOST_BY.YarnRate ? ele.avg_item_diff.toFixed(2) : ele.avg_diff.toFixed(2)}
                                                        </TableCell>
                                                    </TableRow>
                                                )
                                            })
                                        }
                                    </TableBody>
                                </Table>
                            ) : (<div className="text-gray-400  p-7 text-center" >  No Data Found ...</div>)
                        }
                    </div>
                </div>
                <div className="shadow mt-5 ">
                    <div className=" font-semibold flex text-md p-5 text-rose-600 align-top items-center
                                                         tracking-wider
                                           ">
                        <FontAwesomeIcon icon={faChartBar} className=" mr-5 text-md border-0 border-sky-500 text-lime-500" />
                        <div> Quality Cost Summary</div>
                    </div>
                    <ApexCharts
                        options={chartOptions}
                        series={series}
                        type="bar"
                        height={550}
                    /></div>
            </MainContainer>
        </div>
    )
}
export default GrayItemCostingDashboard